import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import enTranslation from "./Utils/languageLocators/en.json";
import vietnamTranslation from "./Utils/languageLocators/vietnam.json";
import frenchTranslation from "./Utils/languageLocators/french.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translations: enTranslation.translations,
      },
      vietnam: {
        translations: vietnamTranslation.translations,
      },
      french: {
        translations: frenchTranslation.translations,
      },
    },
    fallbackLng: "en",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  });



export default i18n;
